import { render } from "./CommonProvinceSelector.vue?vue&type=template&id=4e241002&ts=true&lang=pug"
import script from "./CommonProvinceSelector.vue?vue&type=script&lang=ts"
export * from "./CommonProvinceSelector.vue?vue&type=script&lang=ts"

import "./CommonProvinceSelector.vue?vue&type=style&index=0&id=4e241002&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__